"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FelaHeaderBar = exports.FelaGridLayer = exports.FelaFlexLayer = exports.ruleKeysFlexLayer = exports.FelaRuleLayer = exports.EFelaLayerHeight = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ColorUtils_1 = require("@gt/common-utils/build/general/ColorUtils");
const react_1 = __importDefault(require("react"));
const VibescoutZIndexes_1 = require("../../../styling/VibescoutZIndexes");
const FelaCache_1 = require("../../fela/FelaCache");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaFlexbox_1 = require("./FelaFlexbox");
const FelaGrid_1 = require("./FelaGrid");
const FelaUtility_1 = require("./FelaUtility");
var EFelaLayerHeight;
(function (EFelaLayerHeight) {
    // LIT = "LIT",
    EFelaLayerHeight["HIGH"] = "HIGH";
    EFelaLayerHeight["MID"] = "MID";
    EFelaLayerHeight["LOW"] = "LOW";
    // SHADOW = "SHADOW",
})(EFelaLayerHeight || (exports.EFelaLayerHeight = EFelaLayerHeight = {}));
/*function getBackgroundGradient({ deg = 90, colors }: IGradientColors, theme: IFelaTheme, height: EFelaLayerHeight) {
  return `linear-gradient(${deg}deg, black, white)`;
}*/
const translateOldHeightToNew = {
    [EFelaLayerHeight.HIGH]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.high,
    [EFelaLayerHeight.MID]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.mid,
    [EFelaLayerHeight.LOW]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.deep,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.highest]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.highest,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.high]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.high,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.upper]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.upper,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.mid]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.mid,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.low]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.low,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.deep]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.deep,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.deepest]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.deepest,
    [VibescoutFrontendStyleConfig_1.ESurfaceHeight.shadow]: VibescoutFrontendStyleConfig_1.ESurfaceHeight.shadow,
};
const FelaRuleLayer = ({ theme, forceTheme, height = VibescoutFrontendStyleConfig_1.ESurfaceHeight.mid, shadow = false, extraSoftShadow = false, pop = false, popAmount, popOpacity = 1, popBlur = 0.05, unpop = false, hoverable = false, clickable = false, margin, padding, gradient, radius, backgroundColor, backgroundNeutralColor, backgroundString, borderWidth, borderNeutralColor, borderColorString, borderOpacity, borderHeight, borderStyle, opacity, backgroundOpacity, }) => {
    if (extraSoftShadow) {
        shadow = true;
    }
    const surfaceHeight = translateOldHeightToNew[height];
    const shadowColor = `rgba(${theme.styles.Themes[theme.currentId].shadow.base[0]}, ${theme.styles.Themes[theme.currentId].shadow.intensity})`;
    const setBackgroundColor = backgroundNeutralColor
        ? theme.styles.Themes[theme.currentId].Colors.neutral[backgroundNeutralColor]
        : backgroundColor;
    const shadows = [];
    if (shadow) {
        shadows.push(`0 0.1em 0.3em 0 ${shadowColor}`);
        if (extraSoftShadow) {
            shadows.push(`0 0.2em 1em 0.1em ${shadowColor}`);
        }
    }
    const rules = {
        opacity,
        transition: "all 0.2s ease-out",
        background: gradient
            ? FelaUtility_1.FelaUtility.createGradients(theme, forceTheme ?? theme.currentId, gradient)
            : backgroundString
                ? backgroundString
                : setBackgroundColor !== undefined
                    ? `rgba(${setBackgroundColor[0]}, ${backgroundOpacity ?? 1})`
                    : `rgba(${theme.styles.Themes[forceTheme ?? theme.currentId].Colors.surface[surfaceHeight][0]}, ${backgroundOpacity ?? 1})`,
        margin,
        padding,
        borderRadius: radius,
    };
    if (pop) {
        const popCol = ColorUtils_1.ColorUtils.darkenRgbArray(setBackgroundColor ??
            theme.styles.Themes[forceTheme ?? theme.currentId].Colors.surface[surfaceHeight], 25);
        shadows.push(`${unpop ? "inset " : ""}0 ${popAmount ?? 0.18}em ${popBlur}em 0.05em rgba(${popCol[0]}, ${popOpacity})`);
        /*if (unpop) {
          rules.transform = "translateY(0.18em)";
          shadows.push(`0 -0.18em 0.05em 0.05em rgba(${popCol[0]}, 1)`);
        } else {
    
        }*/
    }
    rules.boxShadow = shadows.length > 0 ? shadows.join(", ") : undefined;
    if (borderWidth) {
        const bbCol = borderNeutralColor
            ? theme.styles.Colors.neutral[borderNeutralColor]
            : borderHeight
                ? theme.styles.Themes[theme.currentId].Colors.surface[borderHeight]
                : setBackgroundColor;
        rules.borderWidth = borderWidth;
        rules.borderStyle = borderStyle ?? "solid";
        rules.borderColor = borderColorString
            ? borderColorString
            : bbCol !== undefined
                ? `rgba(${bbCol[0]}, ${borderOpacity ?? 1})`
                : theme.styles.Themes[forceTheme ?? theme.currentId].RgbColors.surface[surfaceHeight];
        /*rules.border = `${borderWidth} solid ${
          borderColorString
            ? borderColorString
            : bbCol !== undefined
            ? `rgba(${bbCol[0]}, ${borderOpacity ?? 1})`
            : theme.styles.Themes[forceTheme ?? theme.currentId].RgbColors.surface[surfaceHeight]
        }`;*/
    }
    if (clickable) {
        rules.cursor = "pointer";
    }
    if (hoverable) {
        rules[":hover"] =
            backgroundString != null
                ? {
                    filter: "contrast(90%) brightness(115%)",
                }
                : {
                    background: `rgb(${ColorUtils_1.ColorUtils.lightenRgbArray(setBackgroundColor !== undefined
                        ? setBackgroundColor
                        : theme.styles.Themes[forceTheme ?? theme.currentId].Colors.surface[surfaceHeight], 20)[0]})`,
                };
    }
    return rules;
};
exports.FelaRuleLayer = FelaRuleLayer;
exports.ruleKeysFlexLayer = [
    "forceTheme",
    "height",
    "shadow",
    "extraSoftShadow",
    "pop",
    "popAmount",
    "popOpacity",
    "popBlur",
    "unpop",
    "hoverable",
    "clickable",
    "margin",
    "padding",
    "gradient",
    "radius",
    "backgroundColor",
    "backgroundNeutralColor",
    "backgroundString",
    "borderStyle",
    "borderWidth",
    "borderNeutralColor",
    "borderColorString",
    "borderOpacity",
    "borderHeight",
    "opacity",
    "backgroundOpacity",
];
const FelaFlexLayer = ({ children, cssExtra = [], className = "", onClick, onMouseEnter, onMouseLeave, style, rootProps = {}, innerHtml, tag, cssKey, title, ...props }) => {
    // const { css } = useFela(props);
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    /*const divProps: any = {
      onMouseEnter,
      onMouseLeave,
      onClick,
    };*/
    if (innerHtml) {
        rootProps.dangerouslySetInnerHTML = { __html: innerHtml };
    }
    return react_1.default.createElement(tag ?? "div", {
        title,
        onClick,
        onMouseEnter,
        onMouseLeave,
        style,
        // className: `${className} ${css(FelaRuleFlexbox, FelaRuleLayer, ...cssExtra)}`,
        className: `${className} ${cachedClass(FelaFlexbox_1.FelaRuleFlexbox, props, cssKey ?? FelaFlexbox_1.ruleKeysFlexbox)} ${cachedClass(exports.FelaRuleLayer, props, cssKey ?? exports.ruleKeysFlexLayer)} ${inlineCss(cssExtra)}`,
        // dangerouslySetInnerHTML: innerHtml ? { __html: innerHtml } : undefined,
        ...rootProps,
    }, children);
    /*return (
      <div
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={style}
        className={`${className} ${css(FelaRuleFlexbox, FelaRuleLayer, ...cssExtra)}`}
        // dangerouslySetInnerHTML={innerHtml ? { __html: innerHtml! } : undefined}
        {...rootProps}
      >
        {children}
      </div>
    );*/
};
exports.FelaFlexLayer = FelaFlexLayer;
const FelaGridLayer = ({ children, cssExtra = [], className = "", style, onClick, rootProps, title, ...props }) => {
    // const { css } = useFela(props);
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    return ((0, jsx_runtime_1.jsx)("div", { title: title, onClick: onClick, style: style, 
        // className={`${className} ${css(FelaRuleGrid, FelaRuleLayer, ...cssExtra)}`}
        className: `${className} ${cachedClass(FelaGrid_1.FelaRuleGrid, props, FelaGrid_1.ruleKeysFelaGrid)} ${cachedClass(exports.FelaRuleLayer, props, exports.ruleKeysFlexLayer)} ${inlineCss(cssExtra)}`, ...rootProps, children: children }));
};
exports.FelaGridLayer = FelaGridLayer;
const FelaHeaderBar = ({ children, cssExtra = [], className = "", size = 2, padding, sticky = false, ...props }) => {
    return ((0, jsx_runtime_1.jsx)(exports.FelaFlexLayer, { shadow: true, zIndex: VibescoutZIndexes_1.ZIndexes.topBar, height: VibescoutFrontendStyleConfig_1.ESurfaceHeight.highest, className: className, align: "center", position: sticky ? "sticky" : "relative", cssExtra: [
            {
                padding: padding ? padding : size / 4,
                minHeight: size * 2,
            },
            cssExtra,
        ], ...props, children: children }));
};
exports.FelaHeaderBar = FelaHeaderBar;
